import React from "react";

export default function Timers() {
  return <div className="p-8">Timers (coming soon)</div>;
}
